/**
 * Signed-in user access levels. Anonymous visitors have no access level
 * (see useAccessLevel: accessLevel is null when not signed in).
 */
export enum AccessLevel {
  Public = 'Public',
  OntarioHealthcareProfessionals = 'OntarioHealthcareProfessionals',
  SpecialAccess = 'SpecialAccess',
  Admin = 'Admin',
}

/** Legacy Clerk metadata value; treat as SpecialAccess. */
export const LEGACY_SPECIAL_ACCESS_METADATA = 'SpecificUsers';

export const ORBCON_ADMIN_DOMAIN = 'orbcon.ca';
